import { jsx } from "react/jsx-runtime";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { validateTidalLicense } from "../../base/index.js";
function OpenInNew(props) {
  return /* @__PURE__ */ jsx(
    OpenInNewIcon,
    {
      "data-testid": "OpenInNew",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "OpenInNew",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
OpenInNew.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "OpenInNew"
};
validateTidalLicense();
export {
  OpenInNew
};
//# sourceMappingURL=OpenInNew.js.map
